import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type {
  PowerUpServiceRequestBody,
  PowerUpServiceResponseBody,
} from "@vendata/power-up-spec";

export const useSubmitPartInterestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: PowerUpServiceRequestBody["submitBuyInterest"],
    ) => {
      return handleClientMethod(
        getClient().POST("/messages/buy-interest", {
          body: data,
        }),
      );
    },
    onSuccess: (
      data: PowerUpServiceResponseBody["submitBuyInterest"][200],
    ) => {
      queryClient.invalidateQueries({ queryKey: ["buy-interest"] });
      queryClient.invalidateQueries({ queryKey: ["parts", data.partId] });
    },
    onError: (error) => {
      console.error("Failed to submit buy interest:", error);
    },
  });
};
